export const MobileUserEdit = {
    methods:{
       isDesktop(){
            if(device.mobile()){
               return true;
            }else{
                return false;
            }
        },
    },
    created(){
        var return_value = this.isDesktop();
        if(!return_value){
         this.$router.push( '/profile' );   
        }
    }
}